export const colors = [
  "Amber",
  "Apricot",
  "Aqua",
  "Azure",
  "Beige",
  "Black",
  "Blue",
  "Blush",
  "Bronze",
  "Brown",
  "Chocolate",
  "Coffee",
  "Copper",
  "Coral",
  "Crimson",
  "Cyan",
  "Emerald",
  "Gold",
  "Gray",
  "Green",
  "Indigo",
  "Ivory",
  "Jade",
  "Lavender",
  "Lime",
  "Magenta",
  "Maroon",
  "Olive",
  "Orange",
  "Peach",
  "Pink",
  "Plum",
  "Purple",
  "Red",
  "Rose",
  "Salmon",
  "Sapphire",
  "Scarlet",
  "Silver",
  "Tan",
  "Teal",
  "Tomato",
  "Violet",
  "White",
  "Yellow"
];
